import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL || '/_/backend'}/api`;

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // If user data was passed from AuthCallback, use it directly
  useEffect(() => {
    if (location.state?.user) {
      setUser(location.state.user);
      setIsAuthenticated(true);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fetch(`${API}/auth/me`, {
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Not authenticated');
        }
        
        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
        navigate('/login', { state: { from: location.pathname } });
      }
    };
    
    checkAuth();
  }, [navigate, location]);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="animate-pulse text-emerald-950 font-outfit text-lg">
          Loading...
        </div>
      </div>
    );
  }

  // Not authenticated - will be redirected
  if (!isAuthenticated) {
    return null;
  }

  // Check admin requirement
  if (requireAdmin && user?.role !== 'admin') {
    navigate('/dashboard');
    return null;
  }

  // Render children with user data
  return typeof children === 'function' ? children({ user }) : children;
};

export default ProtectedRoute;
